import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_COMMISSION_ROLES:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_COMMISSION_ROLE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_COMMISSION_ROLE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_COMMISSION_ROLE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_COMMISSION_ROLE:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
